import { render, staticRenderFns } from "./SearchClientTableRow.vue?vue&type=template&id=1b08f0f2"
import script from "./SearchClientTableRow.vue?vue&type=script&lang=js"
export * from "./SearchClientTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports